import * as firebase from 'firebase';

/** @description a function to sign out from firebase  */
export const firebaseSignOut = async () => {
  return firebase.auth().signOut();
};
